app.bind('default', function (context) {
    $('[js-animated-load]', context).addClass('is-animate');
    const $animateScroll = $('[js-animated-scroll]', context);
    const $window = $(window);
    $window.on('scroll load', () => {
        $animateScroll.each(function () {
            let $root = $(this);
            if ($root.isInViewport({partially: true}) === true) {
                $root.addClass('is-animate');
            }
        })
    })
});
